import React from 'react';

import application from 'application';

import BasicTextEditor from 'generics/components/basic-text-editor-slate';
import HelptapEditor from 'generics/components/basic-text-editor-slate/helpers';

import './index.scss';

function Playground(props) {

  function renderEditor() {

    const pageId = 'sample-page-id';
    const contentFieldAttributes = {
      id: 'post-editor-' + pageId,
      className: 'textarea-input page-content-field hide-scrollbar',
      placeholder: 'Write something, or type “/” for commands',
      placeholderOnEveryBlock: true,
      pageId,
      parentEntityId: pageId,
      parentEntityType: 'PAGE',
      parentEntity: {},
      value: [HelptapEditor.paragraph.buildNode()],
      enableAdvancedOptions: true,
      onChange(editorState) {
        // handlePageContentChange(editorState);
      },
      focus: true,
      async mediaUploader(file, synchronizedPageRegion) {},
      // disabledElements: getDisabledElements(),
      disableAdvancedDragHandleFeatures: false,
      scrollingContainerSelector: '#playground-main',
      onEditorReady(editor) {
        HelptapEditor.normalize(editor, { force: true });
        HelptapEditor.focusOnFirstLine(editor);
      },
      templates: application.dataManagers.get('TemplatesManager').getAll(),
      direction: application.domUtility.determineLangaugeDetails().dir
    };

    return <BasicTextEditor key={pageId} {...contentFieldAttributes} />;

  }

  function renderMain() {

    return <div id="playground-main">
      {renderEditor()}
    </div>;

  }

  return renderMain();

}

export default Playground;